import { render, staticRenderFns } from "./ForbiddenGoodsTableMobile.vue?vue&type=template&id=032aa34a&scoped=true"
import script from "./ForbiddenGoodsTableMobile.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032aa34a",
  null
  
)

export default component.exports